export default {"src":"/login-app/[GIT_HASH]/_next/static/media/op_dynamic.73f102ff.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};